import React from 'react';
import { Hero } from './components/Hero';
import { MetricsGrid } from './components/MetricsGrid';
import { CalculatorCard } from './components/CalculatorCard';
import { ComparisonTable } from './components/ComparisonTable';
import { Menu, Search } from 'lucide-react';
export function App() {
  return <div className="min-h-screen bg-white flex flex-col" data-id="element-0">
      {/* Navigation */}
      <nav className="border-b border-black sticky top-0 bg-white/95 backdrop-blur-sm z-50" data-id="element-1">
        <div className="flex justify-between items-center h-20 px-6 md:px-12 lg:px-24" data-id="element-2">
          <div className="flex items-center gap-12" data-id="element-3">
            <a href="/" className="text-2xl font-bold tracking-tighter flex items-center gap-2" data-id="element-4">
              <div className="w-6 h-6 bg-[var(--color-swiss-red)]" data-id="element-5"></div>
              HELVETICA
              <span className="font-normal text-gray-400" data-id="element-6">FINANCE</span>
            </a>
            <div className="hidden md:flex gap-8" data-id="element-7">
              <a href="#" className="text-sm font-medium hover:text-[var(--color-swiss-red)] transition-colors" data-id="element-8">
                Services
              </a>
              <a href="#" className="text-sm font-medium hover:text-[var(--color-swiss-red)] transition-colors" data-id="element-9">
                Insights
              </a>
              <a href="#" className="text-sm font-medium hover:text-[var(--color-swiss-red)] transition-colors" data-id="element-10">
                About
              </a>
            </div>
          </div>
          <div className="flex items-center gap-6" data-id="element-11">
            <button className="p-2 hover:bg-gray-100 transition-colors" data-id="element-12">
              <Search className="w-5 h-5" data-id="element-13" />
            </button>
            <button className="p-2 hover:bg-gray-100 transition-colors md:hidden" data-id="element-14">
              <Menu className="w-6 h-6" data-id="element-15" />
            </button>
            <button className="hidden md:block text-sm font-bold uppercase tracking-widest border border-black px-6 py-2 hover:bg-black hover:text-white transition-colors" data-id="element-16">
              Client Login
            </button>
          </div>
        </div>
      </nav>

      <main className="flex-grow" data-id="element-17">
        <Hero data-id="element-18" />

        <MetricsGrid data-id="element-19" />

        {/* Calculators Section */}
        <section id="calculators" className="py-24 px-6 md:px-12 lg:px-24 border-b border-[var(--color-swiss-gray)]" data-id="element-20">
          <div className="max-w-[1440px] mx-auto" data-id="element-21">
            <div className="mb-16 flex flex-col md:flex-row md:items-end justify-between gap-8" data-id="element-22">
              <div data-id="element-23">
                <h2 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-24">
                  Financial Tools
                </h2>
                <p className="text-xl text-gray-600 max-w-2xl" data-id="element-25">
                  Interactive calculators to project your financial future with
                  mathematical accuracy.
                </p>
              </div>
              <div className="w-24 h-1 bg-[var(--color-swiss-red)]" data-id="element-26"></div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-27">
              <CalculatorCard type="retirement" title="Retirement Planner" description="Project your retirement fund growth based on current savings and monthly contributions." data-id="element-28" />
              <CalculatorCard type="savings" title="Savings Goal" description="Calculate the monthly savings required to reach a specific financial target." data-id="element-29" />
              <CalculatorCard type="mortgage" title="Mortgage Estimator" description="Estimate monthly mortgage payments based on loan amount and interest rates." data-id="element-30" />
            </div>
          </div>
        </section>

        {/* Comparison Section */}
        <section className="py-24 px-6 md:px-12 lg:px-24 bg-gray-50" data-id="element-31">
          <div className="max-w-[1440px] mx-auto" data-id="element-32">
            <div className="mb-16" data-id="element-33">
              <h2 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-34">
                Investment Plans
              </h2>
              <p className="text-xl text-gray-600 max-w-2xl" data-id="element-35">
                Transparent comparison of our tiered investment strategies.
              </p>
            </div>

            <div className="bg-white border border-black p-1" data-id="element-36">
              <ComparisonTable data-id="element-37" />
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-32 px-6 md:px-12 lg:px-24 bg-[var(--color-swiss-black)] text-white" data-id="element-38">
          <div className="max-w-[1440px] mx-auto flex flex-col md:flex-row items-start md:items-center justify-between gap-12" data-id="element-39">
            <div data-id="element-40">
              <h2 className="text-5xl md:text-7xl font-bold mb-6 tracking-tight" data-id="element-41">
                Ready to optimize?
              </h2>
              <p className="text-xl text-gray-400 max-w-xl" data-id="element-42">
                Schedule a consultation with our certified financial planners
                today.
              </p>
            </div>
            <button className="bg-white text-black px-12 py-6 text-lg font-bold uppercase tracking-widest hover:bg-[var(--color-swiss-red)] hover:text-white transition-colors duration-300" data-id="element-43">
              Book Consultation
            </button>
          </div>
        </section>
      </main>

      <footer className="border-t border-black py-16 px-6 md:px-12 lg:px-24" data-id="element-44">
        <div className="max-w-[1440px] mx-auto grid grid-cols-1 md:grid-cols-4 gap-12" data-id="element-45">
          <div className="col-span-1 md:col-span-2" data-id="element-46">
            <div className="flex items-center gap-2 mb-8" data-id="element-47">
              <div className="w-5 h-5 bg-[var(--color-swiss-red)]" data-id="element-48"></div>
              <span className="font-bold text-xl tracking-tighter" data-id="element-49">
                HELVETICA FINANCE
              </span>
            </div>
            <p className="text-gray-500 max-w-sm" data-id="element-50">
              Zurich-based financial planning firm dedicated to precision,
              transparency, and long-term wealth preservation.
            </p>
          </div>
          <div data-id="element-51">
            <h4 className="font-bold uppercase tracking-widest mb-6 text-sm" data-id="element-52">
              Office
            </h4>
            <address className="not-italic text-gray-500 space-y-2" data-id="element-53">
              <p data-id="element-54">Bahnhofstrasse 42</p>
              <p data-id="element-55">8001 Zurich</p>
              <p data-id="element-56">Switzerland</p>
            </address>
          </div>
          <div data-id="element-57">
            <h4 className="font-bold uppercase tracking-widest mb-6 text-sm" data-id="element-58">
              Contact
            </h4>
            <div className="text-gray-500 space-y-2" data-id="element-59">
              <p data-id="element-60">+41 44 123 45 67</p>
              <p data-id="element-61">info@helvetica-finance.ch</p>
            </div>
          </div>
        </div>
        <div className="max-w-[1440px] mx-auto mt-16 pt-8 border-t border-gray-200 flex flex-col md:flex-row justify-between text-xs text-gray-400 uppercase tracking-wider" data-id="element-62">
          <p data-id="element-63">© 2024 Helvetica Finance AG. All rights reserved.</p>
          <div className="flex gap-8 mt-4 md:mt-0" data-id="element-64">
            <a href="#" className="hover:text-black" data-id="element-65">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-black" data-id="element-66">
              Terms of Service
            </a>
            <a href="#" className="hover:text-black" data-id="element-67">
              Regulatory
            </a>
          </div>
        </div>
      </footer>
    </div>;
}